export default __webpack_public_path__ + "static/media/BotDefaultAvatar.99b80285.svg";